import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button } from "@babackapp/ui/components/button";
import { GripVertical } from "lucide-react";
import useTranslation from "@babackapp/translations/use-translation";

interface RuleSortableItemProps {
  id: string;
  children: React.ReactNode;
}

export function RuleSortableItem({ id, children }: RuleSortableItemProps) {
  const t = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center group min-h-[36px]"
    >
      {/* Poignée de drag */}
      <Button
        variant="ghost"
        size="sm"
        {...listeners}
        {...attributes}
        className="cursor-grab active:cursor-grabbing p-1 opacity-50 group-hover:opacity-100 transition-opacity"
        title={t("overrideRules.misc.reorderRulesByPriority")}
      >
        <GripVertical className="h-4 w-2 text-muted-foreground" />
      </Button>

      {/* Contenu de la ligne */}
      <div className="flex-1">{children}</div>
    </div>
  );
}
